
import BaseModel from './BaseModel';
import { getMomentDate } from '../utils/commonUtils';
import { TAG_GROUP_SITE_TYPE } from 'constants/Define';
import Translation from './Translation';

const DEFAULT_OPERATING_SCHEDULE = {
    startDate: undefined,
    endDate: undefined,
    repeatType: 0,
    interval: 1,
    daysOfWeek: null,
    daysOfMonth: null,
};

export default class VinwonderTagGroup extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }
    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.name = data.name || (this.translate && this.translate.name) || undefined;
        this.code = data.code || undefined;
        this.isActive = data.hasOwnProperty('isActive') ? data.isActive : true;
        this.translations = (data.translations || []).map(item =>
            (item && typeof item.export === 'function') ? item : new Translation(item)
        );
        this.suppliers = data.suppliers || [];
        this.order = data.order || 0;
        this.siteType = data.siteType || TAG_GROUP_SITE_TYPE.PRODUCT_LISTING;
        this.supplierNamesConfiged = data.supplierNamesConfiged || undefined;
        this.totalSkuConfiged = data.totalSkuConfiged || 0;
        this.totalSupplierConfiged = data.totalSupplierConfiged || 0;
        this.operatingSchedule = {
            ...DEFAULT_OPERATING_SCHEDULE,
            ...(data.operatingSchedule || {}),
            daysOfWeek: Array.isArray(data.operatingSchedule?.daysOfWeek) ? data.operatingSchedule.daysOfWeek : null,
            daysOfMonth: Array.isArray(data.operatingSchedule?.daysOfMonth) ? data.operatingSchedule.daysOfMonth : null,
        };
    }

    export(hasTranslate = false) {
        const result = {
            id: this.id,
            name: this.name,
            code: this.code,
            isActive: this.isActive,
            translations: (this.translations || []).map(item => item.export()),
            suppliers: this.suppliers,
            order: this.order,
            siteType: this.siteType,
            operatingSchedule: this.operatingSchedule,
        }
        if (hasTranslate && this.translate) result.translate = () => {
            return {
                id: this.translate.id,
                vinWonderTagGroupId: this.translate.vinWonderTagGroupId || this.id,
                name: this.name,
                languageCode: this.languageCode,
            }
        }
        return result;
    }
}
